import type { UserSafe } from '@network-verify/shared';

/** localStorage key 常量 */
export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'nv_access_token',
  REFRESH_TOKEN: 'nv_refresh_token',
  USER: 'nv_user',
} as const;

/** 读取 access_token */
export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
  } catch {
    return null;
  }
}

/** 读取 refresh_token */
export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN);
  } catch {
    return null;
  }
}

/** 读取已缓存的用户信息 */
export function getUser(): UserSafe | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEYS.USER);
    if (!raw) return null;
    return JSON.parse(raw) as UserSafe;
  } catch {
    return null;
  }
}

/** 写入 token 对 */
export function setTokens(access_token: string, refresh_token: string): void {
  try {
    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, access_token);
    localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, refresh_token);
  } catch {
    // ignore storage errors (隐私模式等)
  }
}

/** 写入用户信息 */
export function setUser(user: UserSafe): void {
  try {
    localStorage.setItem(TOKEN_KEYS.USER, JSON.stringify(user));
  } catch {
    // ignore
  }
}

/** 移除 token 对 */
export function removeTokens(): void {
  try {
    localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
  } catch {
    // ignore
  }
}

/** 移除用户信息 */
export function removeUser(): void {
  try {
    localStorage.removeItem(TOKEN_KEYS.USER);
  } catch {
    // ignore
  }
}

/** 清空全部鉴权信息 */
export function clearAll(): void {
  removeTokens();
  removeUser();
}
